import React from 'react'
import { useHistory } from 'react-router'
import './TopBannerSlider.scss'
import { BASE_URL } from '../../../config/api.config'

const TopBannerOne = ({ inPlaySlidingBanners }) => {
  const history = useHistory()

  return (
    <div className="banner-one__item">
      <div
        className="banner-one__item_img"
        style={{
          backgroundImage: `url(${
            !inPlaySlidingBanners[0]?.self_host
              ? inPlaySlidingBanners[0]?.description
              : `${BASE_URL}/${inPlaySlidingBanners[0]?.description}`
          })`,
          backgroundColor: inPlaySlidingBanners[0].backgroundColour,
        }}
        // onClick={() => {
        //   history.push(inPlaySlidingBanners[0].redirect)
        //   // if(auth) {
        //   //   history.push(inPlaySlidingBanners[0].redirect)
        //   // } else {
        //   //   dispatch(setLoginNew(true))
        //   // }
        // }}
      />
    </div>
  )
}

export default TopBannerOne
